<template>
  <v-list two-line dense>
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title>
          Dias para conversão
        </v-list-item-title>

        <v-list-item-subtitle>
          {{ daysToConversion }} {{ daysToConversionType }}
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <v-list-item>
      <v-list-item-content>
        <v-list-item-title>
          Dias para liquidação
        </v-list-item-title>

        <v-list-item-subtitle>
          {{ daysToSettlement }} {{ daysToSettlementType }}
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <v-list-item>
      <v-list-item-content>
        <v-list-item-title>
          Resgate mínimo
        </v-list-item-title>

        <v-list-item-subtitle>
          {{ minimumWithdrawal }}
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
import { formatMoney } from '@/utils/format-utils';

const getValue = (val) => val?.$numberDecimal ?? val;

const getDayTypeString = (type) => (type === 'WORKDAYS' ? 'dias úteis' : 'dias corridos');

export default {
  name: 'HouseFundWithdrawalInfo',

  props: {
    info: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    daysToConversion: (vm) => vm.info?.daysToConversion,
    daysToConversionType: (vm) => getDayTypeString(vm.info?.daysToConversionType),
    daysToSettlement: (vm) => vm.info?.daysToSettlement,
    daysToSettlementType: (vm) => getDayTypeString(vm.info?.daysToSettlementType),
    minimumWithdrawal: (vm) => formatMoney(getValue(vm.info?.minimumWithdrawal)),
  },
};
</script>
